// utils
import { mapErrorsToModel } from '@forgeron/utils/api';

export const getModels = async (page = 1, params = null) => {
  let sort = params.sort ? '&sort=' + params.sort : '';
  let size = params.size ? '&page[size]=' + params.size : '';
  let filter = {};
  for (let key in params.filter) {
    filter['filter[' + key + ']'] = params.filter[key];
  }

  return await window.axios
    .get(`/${params.resourceType}?page[number]=` + page + size + sort, {
      params: filter,
      headers: {
        'Content-Type': 'application/vnd.api+json',
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getModel = async (id, resourceType) => {
  return await window.axios
    .get(`/${resourceType}/${id}`, {
      headers: {
        'Content-Type': 'application/vnd.api+json',
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const storeModel = async (model, resourceType) => {
  const method = model.data.id ? 'patch' : 'post';
  if (model.data.id === '' || model.data.id === null) {
    delete model.data.id;
  }

  return await window.axios
    .request({
      url: `/${resourceType}/` + (model.data.id ?? ''),
      method,
      headers: {
        'Content-Type': 'application/vnd.api+json',
      },
      data: { data: model.data },
    })
    .then((response) => {
      if (response.status === 200 || response.status === 201) {
        return response.data;
      }
    })
    .catch((error) => {
      // Wenn Unprocessable Entity
      if (error.response.status === 422) {
        return mapErrorsToModel(error.response.data.errors);
      }
      return error.response.data;
    });
};

export const deleteModel = async (id, resourceType) => {
  return await window.axios
    .delete(`/${resourceType}/${id}`, {
      headers: {
        'Content-Type': 'application/vnd.api+json',
      },
    })
    .then((response) => {
      if (response.status === 204) {
        return response.data;
      }
    });
};
